module.exports = __webpack_public_path__ + "img/book-icon.46a10ea0.png";